module.exports = __webpack_public_path__ + "static/img/join_7.c316578.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join_7.png
// module id = zk1E
// module chunks = 1